import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { DateConfigType } from 'types/State';
import { $PropertyType } from 'utility-types';
import { WEEKENDS_INDEXES } from '@daedalus/core/src/datePicker/config';
interface Props {
  weekdaysShort: $PropertyType<DateConfigType, 'weekdaysShort'>;
  firstDayOfWeek: $PropertyType<DateConfigType, 'firstDayOfWeek'>;
  shouldHighlightWeekend?: boolean;
}
const WeekDaysContainer = /*#__PURE__*/styled('div')({
  name: "WeekDaysContainer",
  class: "w15jt0co",
  propsAsIs: false
});
const WeekDay = /*#__PURE__*/styled('div')({
  name: "WeekDay",
  class: "w1ml2ast",
  propsAsIs: false
});

/* mimics the layout + styling of DatePickerContent to ensure the columns line up */
export const WeekDays = ({
  weekdaysShort,
  firstDayOfWeek,
  shouldHighlightWeekend
}: Props) => {
  // Shift to week start
  const weekEnd = (weekdaysShort || []).slice(0, firstDayOfWeek);
  const weekStart = (weekdaysShort || []).slice(firstDayOfWeek);
  const weekdays = [...weekStart, ...weekEnd];

  // Find indexes of weekend days for the shifted weekdays
  const weekendsIndexes = WEEKENDS_INDEXES.map(index => weekdays.findIndex(weekday => weekday === weekdaysShort[index]));
  return <WeekDaysContainer>
      {weekdays.map((day, index) => <WeekDay key={day} className={cx(weekendsIndexes.includes(index) && shouldHighlightWeekend && 'isWeekend')}>
          {day}
        </WeekDay>)}
    </WeekDaysContainer>;
};

require("./WeekDays.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./WeekDays.tsx");